import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { use, useState } from "react";
import './App.css';
import AdminLayout from "./Component/AdminLayout";
import UserManagerLayout from "./Component/UserManagerLayout";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Dashboard from "./Pages/Dashboard";
import Users from "./Pages/User";
import Courts from "./Pages/Courts";
import Chambers from "./Pages/Chamber";
import CaseStatus from "./Pages/CaseStatus";
import Advocates from "./Pages/Advocates";
import Partys from "./Pages/Partys";
import NewCase from "./Pages/NewCase";
import Cases from "./Pages/Cases";
import AdminDashboard from "./Pages/AdminDashboard"
import Navbar from './Component/Navbar';
import Hero from "./Component/Hero";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={
            <main className="container">
              <Hero />
              <Features />
              <HowItWorks />
              <Testimonials />
              <CTA />
            </main>
          }/>

          
              <Route path="/login" element={isLoggedIn ? (
              localStorage.getItem("role") === "Admin" ? (
                  <Navigate to="/admin" />
                  ) : (
                  <Navigate to="/usermanager" />)
                ) :  (
                <Login setIsLoggedIn={setIsLoggedIn} />)}/>                  
          <Route path="/register" element={<Register />} />

           {/* User Dashboard */}
          {/* <Route path="/dashboard" element={ isLoggedIn && localStorage.getItem("role") === "User" ? (
                <Dashboard />) : (<Navigate to="/login" />)}/> */}
          
          {/* Admin Dashboard */}
          {/* <Route path="/admindashboard" element={ isLoggedIn && localStorage.getItem("role") === "Admin" ? (
                <AdminDashboard />) : (<Navigate to="/login" />)}/> */}
          
          <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<h2>Admin Dashboard Home</h2>} />
          <Route path="users" element={<Users />} />
          <Route path="courts" element={<Courts />} />
          <Route path="chamber" element={<Chambers />} />
          <Route path="status" element={<CaseStatus />} />
          <Route path="advocate" element={<Advocates />} />
          <Route path="party" element={<Partys />} />
        </Route>

        <Route path="/usermanager" element={<UserManagerLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="party" element={<Partys />} />
        <Route path="newcase" element={<NewCase />}/>
        <Route path="cases" element={<Cases />} />
      </Route>
        {/* <Route>
          <Route path="/usermanager" element ={<UserManagerLayout />} />          
        </Route> */}
        
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

function Features() {
  const items = [
    { title: "Case Management", desc: "Track case statuses, deadlines, and documents in one place." },
    { title: "Client Portal", desc: "Secure portal for clients to view case updates and invoices." },
    { title: "Hearing Calendar", desc: "Integrated calendar with reminders for hearings and follow-ups." },
    { title: "Billing & Invoices", desc: "Create invoices, record payments, and export reports." },
  ];

  return (
    <section id="features" className="features">
      <div className="features-header">
        <h2>Everything an advocate needs</h2>
        <p>Simple, secure, and built for legal workflows.</p>
      </div>

      <div className="features-grid">
        {items.map((it) => (
          <div key={it.title} className="feature-card">
            <div className="feature-title">{it.title}</div>
            <div className="feature-desc">{it.desc}</div>
            <div className="feature-link">Learn more →</div>
          </div>
        ))}
      </div>

      {/* Inline CSS (move to Features.css if you prefer) */}
      <style>{`
        .features {
          padding: 3rem 0;
        }
        .features-header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .features-header h2 {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        .features-header p {
          color: #6b7280;
          font-size: 0.95rem;
        }
        .features-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.5rem;
        }
        @media (min-width: 640px) {
          .features-grid { grid-template-columns: 1fr 1fr; }
        }
        @media (min-width: 1024px) {
          .features-grid { grid-template-columns: 1fr 1fr 1fr 1fr; }
        }
        .feature-card {
          background: #fff;
          padding: 20px;
          border-radius: 12px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
          transition: transform 0.2s ease;
        }
        .feature-card:hover {
          transform: translateY(-4px);
        }
        .feature-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        .feature-desc {
          font-size: 0.9rem;
          color: #6b7280;
        }
        .feature-link {
          margin-top: 1rem;
          color: #4f46e5;
          font-size: 0.9rem;
          font-weight: 500;
          cursor: pointer;
        }
        .feature-link:hover {
          text-decoration: underline;
        }
      `}</style>
    </section>
  );
}
function HowItWorks() {
  const steps = [
    { title: "Sign up & Import", desc: "Create your account and import clients and cases quickly." },
    { title: "Organize Cases", desc: "Create case files, upload documents, and assign tasks." },
    { title: "Automate Reminders", desc: "Auto reminders for hearings, payments and deadlines." },
  ];

  return (
    <section id="how" className="how">
      <div className="how-header">
        <h3>How it works</h3>
        <p>From sign-up to courtroom — three steps to start managing smarter.</p>
      </div>

      <div className="steps">
        {steps.map((s, i) => (
          <div key={s.title} className="step">
            <div className="step-circle">{i + 1}</div>
            <h4>{s.title}</h4>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>

      {/* Inline CSS (move into HowItWorks.css if you prefer) */}
      <style>{`
        .how {
          padding: 3rem 0;
        }
        .how-header {
          max-width: 700px;
          margin: 0 auto 2rem;
          text-align: center;
        }
        .how-header h3 {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }
        .how-header p {
          color: #6b7280;
          font-size: 0.95rem;
        }
        .steps {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.5rem;
        }
        @media (min-width: 768px) {
          .steps { grid-template-columns: repeat(3, 1fr); }
        }
        .step {
          background: #fff;
          padding: 24px;
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        }
        .step-circle {
          width: 48px;
          height: 48px;
          margin: 0 auto;
          border-radius: 50%;
          background: #eef2ff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: #4f46e5;
        }
        .step h4 {
          margin-top: 1rem;
          font-weight: 600;
          font-size: 1rem;
        }
        .step p {
          margin-top: 0.5rem;
          font-size: 0.9rem;
          color: #6b7280;
        }
      `}</style>
    </section>
  );
}
function Testimonials() {
  const data = [
    { name: "Advocate R. Singh", quote: "Saved us hours every week. Excellent support." },
    { name: "Law Firm — Rohan & Co.", quote: "Easy to use and secure for clients." },
  ];

  return (
    <section className="testimonials">
      <div className="testimonials-header">
        <h3>Trusted by advocates</h3>
      </div>

      <div className="testimonials-grid">
        {data.map((t) => (
          <div key={t.name} className="testimonial-card">
            <p>“{t.quote}”</p>
            <div className="testimonial-name">{t.name}</div>
          </div>
        ))}
      </div>

      <style>{`
        .testimonials {
          padding: 3rem 0;
        }
        .testimonials-header {
          text-align: center;
          margin-bottom: 1.5rem;
        }
        .testimonials-header h3 {
          font-size: 1.25rem;
          font-weight: 600;
        }
        .testimonials-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1.5rem;
        }
        @media (min-width: 768px) {
          .testimonials-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        .testimonial-card {
          background: #fff;
          padding: 24px;
          border-radius: 12px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
        }
        .testimonial-card p {
          color: #374151;
          font-size: 0.95rem;
          line-height: 1.5;
        }
        .testimonial-name {
          margin-top: 1rem;
          font-weight: 600;
          color: #111827;
        }
      `}</style>
    </section>
  );
}
function CTA() {
  return (
    <section id="pricing" className="cta">
      <div className="cta-box">
        <h3>Ready to organize your practice?</h3>
        <p>Start with a free trial — no credit card required.</p>
        <div className="cta-actions">
          <a href="#" className="btn-primary">Start Free Trial</a>
          <a href="#" className="btn-outline">Talk to Sales</a>
        </div>
      </div>

      <style>{`
        .cta {
          padding: 3rem 0;
        }
        .cta-box {
          max-width: 720px;
          margin: 0 auto;
          text-align: center;
          padding: 2.5rem;
          background: #eef2ff;
          border-radius: 12px;
        }
        .cta-box h3 {
          font-size: 1.5rem;
          font-weight: 600;
        }
        .cta-box p {
          margin-top: 0.5rem;
          color: #4b5563;
          font-size: 1rem;
        }
        .cta-actions {
          margin-top: 1.5rem;
          display: flex;
          justify-content: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        .btn-primary {
          display: inline-block;
          padding: 0.75rem 1.5rem;
          border-radius: 6px;
          background: #4f46e5;
          color: white;
          font-weight: 500;
          text-decoration: none;
          transition: background 0.2s ease;
        }
        .btn-primary:hover {
          background: #4338ca;
        }
        .btn-outline {
          display: inline-block;
          padding: 0.75rem 1.5rem;
          border-radius: 6px;
          border: 1px solid #d1d5db;
          color: #111827;
          font-weight: 500;
          text-decoration: none;
          transition: background 0.2s ease;
        }
        .btn-outline:hover {
          background: #f9fafb;
        }
      `}</style>
    </section>
  );
}
function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">Advocate</div>
          <div className="footer-copy">
            © {new Date().getFullYear()} Codelover Technology. All rights reserved.
          </div>
        </div>

        <div className="footer-info">
          <div className="footer-links">Privacy · Terms</div>
          <div className="footer-note">Built with ❤ for legal professionals.</div>
        </div>
      </div>

      <style>{`
        .footer {
          margin-top: 3rem;
          background: #fff;
          border-top: 1px solid #e5e7eb;
        }
        .footer-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem 1.5rem;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }
        @media (min-width: 768px) {
          .footer-inner {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
          }
        }
        .footer-logo {
          font-weight: 600;
          font-size: 1rem;
          margin-bottom: 0.25rem;
        }
        .footer-copy {
          font-size: 0.75rem;
          color: #6b7280;
        }
        .footer-info {
          font-size: 0.875rem;
          color: #4b5563;
        }
        .footer-links {
          margin-bottom: 0.5rem;
        }
        .footer-note {
          font-size: 0.75rem;
          color: #9ca3af;
        }
      `}</style>
    </footer>
  );
}
function LayoutWrapper({ children, allowedRoles }) {
  const location = useLocation();

  // hide Navbar/Footer on Dashboard page
  const hideNavbarFooter = location.pathname === "/usermanager" || location.pathname.startsWith("/admin");
  
  return (
    <div className="app">
      {!hideNavbarFooter && <Navbar />}
      {children}
      {!hideNavbarFooter && <Footer />}
    </div>
  );
}


export default App;
